import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Container from "@mui/material/Container";
import Header from "../components/shared/Header";
import Menu from "../components/shared/Menu";

const MainLayout: React.FC = () => {
  const [open, setOpen] = useState(true);

  const toggleDrawer = (open: boolean) => {
    setOpen(open);
  };

  return (
    <>
      <Header open={open} setOpen={toggleDrawer} />
      <Menu open={open} setOpen={toggleDrawer} />

      <Container
        sx={{
          padding: "80px 0 0 0 !important",
          bgcolor: "background.default",
          ml: open ? "240px" : 0,
          width: open ? "calc(100% - 240px)" : "100%",
        }}
        maxWidth={false}
      >
        <Outlet />
      </Container>
    </>
  );
};

export default MainLayout;
